import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { contactInfo } from '../mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        height: '80px',
        background: isScrolled ? 'rgba(44, 52, 64, 0.98)' : 'rgba(44, 52, 64, 0.95)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        transition: 'all 0.3s ease',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: isScrolled ? '0 4px 20px rgba(0, 0, 0, 0.3)' : 'none'
      }}
    >
      <div className="container" style={{ height: '100%' }}>
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%'
        }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer' }}
               onClick={() => scrollToSection('hero')}>
            <div style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
                <circle cx="50" cy="50" r="45" fill="none" stroke="#987D9C" strokeWidth="2"/>
                <circle cx="50" cy="50" r="8" fill="#987D9C"/>
                <circle cx="50" cy="20" r="6" fill="#768597"/>
                <circle cx="80" cy="50" r="6" fill="#BCA182"/>
                <circle cx="50" cy="80" r="6" fill="#FCC9C7"/>
                <circle cx="20" cy="50" r="6" fill="#b8d1ba"/>
                <line x1="50" y1="50" x2="50" y2="20" stroke="#999999" strokeWidth="1"/>
                <line x1="50" y1="50" x2="80" y2="50" stroke="#999999" strokeWidth="1"/>
                <line x1="50" y1="50" x2="50" y2="80" stroke="#999999" strokeWidth="1"/>
                <line x1="50" y1="50" x2="20" y2="50" stroke="#999999" strokeWidth="1"/>
              </svg>
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: '1.125rem', color: '#FFFFFF' }}>CRN</div>
              <div style={{ fontSize: '0.625rem', color: '#A0A8B0', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Healing Starts Within</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div style={{ display: 'none', alignItems: 'center', gap: '2rem' }} className="desktop-nav">
            <button onClick={() => scrollToSection('about')} className="body-small" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E0E0E0', transition: 'color 0.2s' }}>About</button>
            <button onClick={() => scrollToSection('benefits')} className="body-small" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E0E0E0', transition: 'color 0.2s' }}>Benefits</button>
            <button onClick={() => scrollToSection('faq')} className="body-small" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E0E0E0', transition: 'color 0.2s' }}>FAQ</button>
            <button onClick={() => scrollToSection('contact')} className="btn-primary">Schedule Consultation</button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="mobile-menu-toggle"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem',
              color: '#FFFFFF'
            }}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div style={{
            position: 'absolute',
            top: '80px',
            left: 0,
            right: 0,
            background: '#2C3440',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            padding: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}>
            <button onClick={() => scrollToSection('about')} className="body-medium" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E0E0E0', textAlign: 'left', padding: '0.5rem 0' }}>About</button>
            <button onClick={() => scrollToSection('benefits')} className="body-medium" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E0E0E0', textAlign: 'left', padding: '0.5rem 0' }}>Benefits</button>
            <button onClick={() => scrollToSection('faq')} className="body-medium" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E0E0E0', textAlign: 'left', padding: '0.5rem 0' }}>FAQ</button>
            <button onClick={() => scrollToSection('contact')} className="btn-primary" style={{ marginTop: '1rem' }}>Schedule Consultation</button>
          </div>
        )}
      </div>

      <style>{`
        @media (min-width: 768px) {
          .desktop-nav {
            display: flex !important;
          }
          .mobile-menu-toggle {
            display: none !important;
          }
        }
        @media (max-width: 767px) {
          .desktop-nav {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};
